"use client";
import { jsxs as i, jsx as h } from "react/jsx-runtime";
import b from "../../icon/Icon.js";
import x from "classnames";
import '../../../assets/Checkbox.css';const l = "_checkbox_b33ko_2", d = "_icon_b33ko_14", e = {
  checkbox: l,
  "custom-icon-checkbox-container": "_custom-icon-checkbox-container_b33ko_8",
  icon: d
}, r = ({ id: n, name: k, label: o, className: m, indeterminate: t, ...c }) => /* @__PURE__ */ i("label", { "data-testid": "checkbox-label", htmlFor: n, className: x(e.checkbox, m), children: [
  /* @__PURE__ */ i("span", { className: e["custom-icon-checkbox-container"], children: [
    /* @__PURE__ */ h(
      "input",
      {
        "data-testid": "checkbox-input",
        type: "checkbox",
        "data-indeterminate": !c.checked && t,
        id: n,
        name: k,
        ...c,
        onChange: (s) => {
          var a;
          (a = c == null ? void 0 : c.onChange) == null || a.call(c, s);
        }
      }
    ),
    /* @__PURE__ */ h(b, { name: !c.checked && t ? "minus" : "check", className: e.icon })
  ] }),
  !!o && o
] });
export {
  r as default
};
